import Network from '../../../../infrastructure/js/modules/network.js';

const getEnums = function(){
  return Network.get('enum/all');
};

export default {getEnums};
